import { ColumnConfig, ColumnType } from "../Shared/Components/DataTable";
import { BankAccount } from "./Types/bankAccountTypes";

export const columnBankAccounts: ColumnConfig<BankAccount>[] = [
	{
		key: "accountNumber",
		label: "Numer konta",
		render: (row) => row.accountNumber,
	},
	{
		key: "bankName",
		label: "Nazwa banku",
		render: (row) => row.bankName,
	},
	{
		key: "bankBranch",
		label: "Oddział banku",
		render: (row) => row.bankBranch,
		type: ColumnType.text,
	},
	{
		key: "currency",
		label: "Waluta",
		type: ColumnType.text,
		parseValue: (val) => String(val),
	},
	{
		key: "description",
		label: "Opis",
		type: ColumnType.text,
		render: (row) => row.description,
	},
];
